import { addDays } from 'date-fns/addDays';
import { format } from 'date-fns/format';
import { subDays } from 'date-fns/subDays';

import { toDateTimestamp } from '../../logical/date-value.js';
import { t } from '../../logical/type-presets.js';
import { createFilter } from './create.js';

export const dateFilter = [
  createFilter({
    name: 'before',
    self: t.date.instance(),
    args: [t.date.instance()] as const,
    label: 'Before',
    shortString: v => (v ? ` < ${format(v.value, 'yyyy/MM/dd')}` : undefined),
    impl: (self, value) => {
      // date-range columns reach here as an object, so unwrap before comparing
      const start = toDateTimestamp(self);
      if (start == null) {
        return false;
      }
      return start < value;
    },
    defaultValue: args => subDays(args[0], 1).getTime(),
  }),
  createFilter({
    name: 'after',
    self: t.date.instance(),
    args: [t.date.instance()] as const,
    label: 'After',
    shortString: v => (v ? ` > ${format(v.value, 'yyyy/MM/dd')}` : undefined),
    impl: (self, value) => {
      const start = toDateTimestamp(self);
      if (start == null) {
        return false;
      }
      return start > value;
    },
    defaultValue: args => addDays(args[0], 1).getTime(),
  }),
];
